export const EVENT = {
    CAPTCHA_INIT: 'CAPTCHA_INIT',
}